import Vue from 'vue';
Vue.directive('focus', {
  inserted: function inserted(el) {
    console.log(el);
    console.log('inserted');
    el.focus();
  },
  update: function update(el) {
    console.log('update');
  }
});
Vue.directive('check-all', {
  bind: function bind(el, binding) {
    var checkData = JSON.parse(el.dataset.checkData);

    if (checkData.every(function (item) {
      return item.checked;
    })) {
      el.dataset.checkAll = true;
    } else {
      el.dataset.checkAll = false;
    }
  },
  update: function update(checkAll) {}
});